import {BtxId, ProjectId, TicketId, UserId} from "./ids";
import {UseCaseInvocation, useCaseInvocationFromBackendObject} from "./use-case-invocation";

export interface BusinessTransaction {
    btxId: BtxId,
    projectId: ProjectId,
    userId: UserId,
    state: string,
    startTime: Date,
    optEndTime: Date,
    tickets: TicketId[],
    useCaseInvocation: UseCaseInvocation
}

/** helper function to make front-end specific modification to Devices */
export function businessTransactionFromBackendObject(btx: any): BusinessTransaction{
    btx['useCaseInvocation'] = useCaseInvocationFromBackendObject(btx.useCaseInvocation)
    return btx as BusinessTransaction;
}
